import React, { useEffect, useState } from 'react';
import { Table, Button, Row, Col, notification, Select, Tooltip, Tabs } from 'antd';
import { IoIosList, IoMdDocument, IoMdCalendar } from "react-icons/io";
import { CgListTree } from "react-icons/cg";
import { RiFileExcel2Fill } from "react-icons/ri";
import { getMovTypes } from '../services/movementTypeService';
import { getProducts } from '../services/ProductsService';
import { getActiveCategories } from '../services/CategoriesService';
import { getAllPlants } from '../services/PlantsService';
import { getAllMovements } from '../services/logisticMovementService';
import ReactExport from "react-export-excel";
import moment from 'moment';
import { dateFormat } from "../config.json";

import MovementProductsModal from './MovementProductsModal';
import ModalFecha from './ModalFecha';
import ModalCategory from './ModalCategory';


const { TabPane } = Tabs;
const { Option } = Select;
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function MovementMaterials(){
  const[dataTable, setDataTable] = useState([]);
  const[dataTableDetalle, setDataTableDetalle] = useState([]);
  const[dataTableCompleta, setDataTableCompleta] = useState([]);
  const[tableLoading, setTableLoading] = useState(false);
  const[tableLoadingDetalle, setTableLoadingDetalle] = useState(false);
  const[movLoading, setMovLoading] = useState(false);
  const[storageLoading, setStorageLoading] = useState(false);
  const[dataProducts, setDataProducts] = useState([]);
  const[dataCategories, setDataCategories] = useState([]);
  const[dataMovementType, setDataMovementType] = useState([]);
  const[dataPlantsStorage, setDataPlantsStorage] = useState([]);
  const[dataStorage, setDataStorage] = useState([]);
  const[modalVisibleProducts, setModalVisibleProducts] = useState(false);
  const[modalVisibleFecha, setModalVisibleFecha] = useState(false);
  const[modalVisibleCat, setModalVisibleCat] = useState(false);
  const[filterCategory, setfilterCategory] = useState([]);
  const[selectedProducts, setSelectedProducts] = useState([]);
  const[selectedMovTypes, setSelectedMovTypes] = useState([]);
  const[selectedStorage, setSelectedStorage] = useState([]);
  const[selectedStorageDest, setSelectedStorageDest] = useState([]);
  const[selectedPlants, setSelectedPlants] = useState([]);
  const[selectedPlantsDest, setSelectedPlantsDest] = useState([]);
  const[selectedFechas, setSelectedFechas] = useState([]);
  const[selectedCat, setSelectedCat] = useState([]);
  const[btnExcelVisible, setBtnExcelVisible] = useState(false);
  

    useEffect(() => {
      async function plantsStorage(){
        setStorageLoading(true);
        const { data } = await getAllPlants();
        setDataPlantsStorage(data);
        setDataStorage(data[0].storageLocations);
        setStorageLoading(false);
      }
      async function categorias(){
        const { data } = await getActiveCategories();
        const filter = [];
        data.map(function(obj){
          const item = {
            "text": obj.name,
            "value": obj.name
          };
          filter.push(item);
          return true;
        });
        setDataCategories(data);
        setfilterCategory(filter);
      }
        async function movTypes(){
          setMovLoading(true);
          const { data } = await getMovTypes();
          setDataMovementType(data);
          setMovLoading(false);
        }
        async function products(){
            const { data } = await getProducts();
            setDataProducts(data);
        }
        plantsStorage();
        products();
        movTypes();
        categorias();
        
    },[])

    const msNotification = (type, title, desc) => {
      notification[type]({
        message: title,
        description:
          desc,
      });
    };

    function handleChangePlant(value) {
      setSelectedPlants(value);
        
    }

    function handleChangePlantDest(value) {
      setSelectedPlantsDest(value);
        
    }

    function handleChangeStorage(value) {
      setSelectedStorage(value);
        
    }

    function handleChangeStorageDest(value) {
      setSelectedStorageDest(value);
        
    }

    function handleChangeMovTypes(value) {
      setSelectedMovTypes(value);
      
    }

    const handleCancelModalProducts = () =>{
      setModalVisibleProducts(false);
    }

    const handleOkModalProducts = (data) =>{
      setSelectedProducts(data);
      setModalVisibleProducts(false);
    }

    const handleClickModalMovProd = () =>{
      setModalVisibleProducts(true);
    }

    const handleCancelModalFecha = () =>{
      setModalVisibleFecha(false);
    }

    const handleOkModalFecha = (data) =>{
      const dataUTC = [];      
        for (let i = 0; i < data.length; i++) {
          const elementUTC = data[i];

          if(elementUTC.high != null){
            let fecha = elementUTC.low.split("/");
            let newDate = new Date(fecha[2]+"-"+fecha[1]+"-"+fecha[0]+" 00:00:00");
            let fecha2 = elementUTC.high.split("/");
            let newDate2 = new Date(fecha2[2]+"-"+fecha2[1]+"-"+fecha2[0]+" 00:00:00");
            dataUTC.push({
              key: dataUTC.length+1,
              option: elementUTC.option,
              sign: elementUTC.sign,
              low: newDate,
              high: newDate2
            });
          }else{
            let fecha = elementUTC.low.split("/");
            let newDate = new Date(fecha[2]+"-"+fecha[1]+"-"+fecha[0]+" 00:00:00");
            dataUTC.push({
              key: dataUTC.length+1,
              option: elementUTC.option,
              sign: elementUTC.sign,
              low: newDate,
              high: null
            });
          }
          
        }
        setSelectedFechas(dataUTC);
        setModalVisibleFecha(false);
    }

    const handleClickModalFecha = () =>{
      setModalVisibleFecha(true);
    }

    const handleCancelModalCat = () =>{
      setModalVisibleCat(false);
    }

    const handleOkModalCat = (data) =>{
      setSelectedCat(data);
      setModalVisibleCat(false);
    }

    const handleClickModalCat = () =>{
      setModalVisibleCat(true);
    }

    const handleClickDetalle = (record) => {
      setTableLoadingDetalle(true);
      setDataTableDetalle([]);
      setDataTableDetalle(record.movementDetails);
      setTableLoadingDetalle(false);
    }

    const handleClickReport = async () =>{
      setDataTable([]);
      setDataTableDetalle([]);
      setDataTableCompleta([]);
      setBtnExcelVisible(false);
      const request = {
        "Plants" : selectedPlants,
        "MovementTypes" : selectedMovTypes,
        "Products" : selectedProducts,
        "StorageLocations" : selectedStorage,
        "CategoriesRange" : selectedCat,
        "DestinationPlants" : selectedPlantsDest,
        "DestinationStorageLocations" : selectedStorageDest,
        "DateRange" : selectedFechas,
      }
      setTableLoading(true);
      async function getReport(){
        const { data } = await getAllMovements(request);
        
        if(data.length === 0){
          msNotification('info', 'Reporte', 'No se encontraron datos con los filtros seleccionados.' );
          setTableLoading(false);
          return false;
        }else{
          setBtnExcelVisible(true);
          let dorder = data.sort(function(a,b){
            return Number(a.id) - Number(b.id);
          });
          setDataTable(dorder);
        }

        const dataModel = [];
        let indx = 1;
        for (let x = 0; x < data.length; x++) {
          const header = data[x];
          if(header.movementDetails.length > 0){
            for (let y = 0; y < data[x].movementDetails.length; y++) {
              
              const detail = data[x].movementDetails[y];
              dataModel.push({
                key: indx,
                id: Number(header.id),
                customer: header.customer,
                organization: header.organization,
                movementType: header.movementType,
                user: header.user,
                date: header.date,
                position: detail.position,
                product: detail.product,
                category: detail.category,
                costCenter: detail.costCenter,
                plant: detail.plant,
                unitCost: detail.unitCost,
                destinationPlant: detail.destinationPlant,
                storageLocation: detail.storageLocation,
                destinationStorageLocation: detail.destinationStorageLocation,
                quantity: detail.quantity,
                unitOfMeasure: detail.unitOfMeasure,
                text: detail.text,
              });
              indx++;
            }
          }
        }
        let dataOrder = dataModel.sort(function(a,b){
          return a.id - b.id;
        });
        setDataTableCompleta(dataOrder);

        setTableLoading(false);
      }
      getReport();
    }

    const formatDate = (current_datetime)=>{
      let formatted_date = moment.utc(current_datetime).local().format(dateFormat);
        return formatted_date;
    }

    function callback(key) {
    }

    const rowClassColor = (record, index) => record.movementType.id.charAt(0) === '1' ? 'rowGreen' : record.movementType.id.charAt(0) === '2' ? 'rowRed' : "hola-nene";

    const columns = [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        width: 100,
      },
      {
        title: 'Movimiento',
        dataIndex: 'movementType',
        render: (value) => (value.name === "" ? value.id : value.id + " - " + value.name)
      },
      {
        title: 'Usuario',
        dataIndex: 'user',
        render: (value) => (value.userName)
      },
      {
        title: 'Fecha',
        dataIndex: 'date',
        render: (value) => (formatDate(value))
      },
      {
        title: 'Detalle',
        align: 'center',
        fixed: 'right',
        width: 100,
        render: (value, record) => (
          <React.Fragment>
            <Tooltip title="Detalle">
              <Button type="primary" shape="circle" onClick={() => handleClickDetalle(record)} icon={<CgListTree />} />
            </Tooltip>
          </React.Fragment>)
      },
      
      
    ];

    const columnsDetalle = [
      {
        title: 'Posición',
        dataIndex: 'position',
        width: 100,
        fixed: 'left',
        render: (value) => (value)
      },
      {
        title: 'Producto',
        dataIndex: 'product',
        render: (value) => (value.name)
      },
      {
        title: 'Categoría',
        dataIndex: 'category',
        render: (value) => (value == null ? "" : value.name)
      },
      {
        title: 'Centro costo',
        dataIndex: 'costCenter',
        render: (value) => (value == null ? "" : value.id)
      },
      {
        title: 'Planta',
        dataIndex: 'plant',
        render: (value) => (value.name)
      },
      {
        title: 'Planta destino',
        dataIndex: 'destinationPlant',
        render: (value) => (value == null ? "": value.name)
      },
      {
        title: 'Almacén',
        dataIndex: 'storageLocation',
        render: (value) => (value == null ? "" : value.name)
      },
      {
        title: 'Almacén destino',
        dataIndex: 'destinationStorageLocation',
        render: (value) => (value == null ? "": value.name)
      },
      
      {
        title: 'Costo',
        dataIndex: 'unitCost',
        render: (value) => ("$"+value)
      },
      {
        title: 'Cantidad',
        dataIndex: 'quantity',
        render: (value) => (value)
      },
      {
        title: 'Unidad',
        dataIndex: 'unitOfMeasure',
        render: (value) => (value.unit)
      },
      {
        title: 'Texto',
        dataIndex: 'text',
        render: (value) => (value)
      },
      
    ];

    const columnsComplete = [
      {
        title: 'ID',
        dataIndex: 'id',
        width: 100,
        fixed: 'left',
      },
      {
        title: 'Movimiento',
        dataIndex: 'movementType',
        render: (value) => (value.name === "" ? value.id : value.id + " - " + value.name)
      },
      {
        title: 'Usuario',
        dataIndex: 'user',
        width: 300,
        render: (value) => (value.userName)
      },
      {
        title: 'Fecha',
        dataIndex: 'date',
        render: (value) => (formatDate(value))
      },
      {
        title: 'Posición',
        dataIndex: 'position',
        width: 100,
        render: (value) => (value)
      },
      {
        title: 'Producto',
        dataIndex: 'product',
        render: (value) => (value.name)
      },
      {
        title: 'Categoría',
        dataIndex: 'category',
        render: (value) => (value == null ? "" : value.name)
      },
      {
        title: 'Centro costo',
        dataIndex: 'costCenter',
        render: (value) => (value == null ? "" : value.id)
      },
      {
        title: 'Planta',
        dataIndex: 'plant',
        render: (value) => (value.name)
      },
      {
        title: 'Planta destino',
        dataIndex: 'destinationPlant',
        render: (value) => (value == null ? "": value.name)
      },
      {
        title: 'Almacén',
        dataIndex: 'storageLocation',
        render: (value) => (value == null ? "" : value.name)
      },
      {
        title: 'Almacén destino',
        dataIndex: 'destinationStorageLocation',
        render: (value) => (value == null ? "": value.name)
      },
      
      {
        title: 'Costo',
        dataIndex: 'unitCost',
        width: 120,
        render: (value) => ("$"+value)
      },
      {
        title: 'Cantidad',
        dataIndex: 'quantity',
        width: 120,
        render: (value) => (value)
      },
      {
        title: 'Unidad',
        dataIndex: 'unitOfMeasure',
        width: 120,
        render: (value) => (value.unit)
      },
      {
        title: 'Texto',
        dataIndex: 'text',
        render: (value) => (value)
      },
      
    ];
    
    

    return(
      <div className="mainContainer">

        <MovementProductsModal modalVisibleProducts={modalVisibleProducts} 
        handleCancelModalProducts={handleCancelModalProducts}
        handleOkModalProducts={handleOkModalProducts}
        dataProducts={dataProducts}
        filterCategory={filterCategory}/>

        <ModalFecha modalVisibleFecha={modalVisibleFecha} 
        handleCancelModalFecha={handleCancelModalFecha}
        handleOkModalFecha={handleOkModalFecha}/>

        <ModalCategory modalVisibleCat={modalVisibleCat} 
        handleCancelModalCat={handleCancelModalCat}
        handleOkModalCat={handleOkModalCat}
        dataCategories={dataCategories}/>

        <Row>
            <Col span={24}>
                <h1 className="title">Reporte de movimientos</h1>
                <hr className="hr-title"/>
            </Col>
        </Row>

        <Row className="detailContainer">
          <Col span={20}></Col>
          <Col span={4}>
            <div className="">
              <Button block type="primary" icon={<IoMdDocument/>} onClick={handleClickReport}>
                &nbsp; Generar
              </Button>
            </div>
          </Col>
          <Col span={24}><br /></Col>

          <Col span={8}>
            <div className="">
              <Button block type="primary" icon={<IoIosList/>} onClick={handleClickModalMovProd}>
                &nbsp; Productos...
              </Button>
            </div>
          </Col>
          <Col span={2}></Col>
          <Col span={8}>
            <div className="">
              <Button block type="primary" icon={<IoIosList/>} onClick={handleClickModalCat}>
                &nbsp; Categorias...
              </Button>
            </div>
          </Col>
          <Col span={6}></Col>
          <Col span={24}><br /></Col>

          <Col span={8}>
            <div className="">
              <Button block type="primary" icon={<IoMdCalendar/>} onClick={handleClickModalFecha}>
                &nbsp; Fechas...
              </Button>
            </div>
          </Col>
          <Col span={2}></Col>
          <Col span={8}>
            <Select mode="multiple" loading={movLoading} style={{ width: '100%' }} 
              onChange={handleChangeMovTypes} 
              placeholder="Movimientos..."
              maxTagCount='responsive'>
                {dataMovementType.map(function(obj){
                    return <Option key={obj.id} value={obj.id}>{obj.name === "" ? obj.id : obj.id +" - "+ obj.name}</Option>
                })}
            </Select>
            
          </Col>
          <Col span={6}></Col>
          <Col span={24}><br /></Col>

          <Col span={8}>
            <Select mode="multiple" loading={storageLoading} style={{ width: '100%' }} 
              onChange={handleChangePlant} 
              placeholder="Plantas..."
              maxTagCount='responsive'>
                {dataPlantsStorage.map(function(obj){
                    return <Option key={obj.id} value={obj.id}>{obj.name}</Option>
                })}
            </Select>
          </Col>
          <Col span={2}></Col>
          <Col span={8}>
            <Select mode="multiple" loading={storageLoading} style={{ width: '100%' }} 
              onChange={handleChangePlantDest} 
              placeholder="Plantas destino..."
              maxTagCount='responsive'>
                {dataPlantsStorage.map(function(obj){
                    return <Option key={obj.id} value={obj.id}>{obj.name}</Option>
                })}
            </Select>
            
          </Col>
          <Col span={6}></Col>
          <Col span={24}><br /></Col>

          <Col span={8}>
            <Select mode="multiple" loading={storageLoading} style={{ width: '100%' }} 
              onChange={handleChangeStorage} 
              placeholder="Almacenes..."
              maxTagCount='responsive'>
                {dataStorage.map(function(obj){
                    return <Option key={obj.id} value={obj.id}>{obj.name}</Option>
                })}
            </Select>
          </Col>
          <Col span={2}></Col>
          <Col span={8}>
            <Select mode="multiple" loading={storageLoading} style={{ width: '100%' }} 
              onChange={handleChangeStorageDest} 
              placeholder="Almacenes destino..."
              maxTagCount='responsive'>
                {dataStorage.map(function(obj){
                    return <Option key={obj.id} value={obj.id}>{obj.name}</Option>
                })}
            </Select>
          </Col>
          <Col span={6}></Col>
          <Col span={24}><br /></Col>
          <Col span={24}>
            <Tabs onChange={callback} type="card">
            <TabPane tab="Reporte acumulado" key="1">
                <Row>
                  <Col span={24}><br /></Col>
                  <Col span={6} className={"collapse" + (btnExcelVisible ? 'in' : '')}>
                    <ExcelFile filename="Reporte-Movimientos" element={<Button block type="primary" icon={<RiFileExcel2Fill/>}> Descargar datos</Button>}>
                        <ExcelSheet data={dataTableCompleta} name="Reporte de Movimientos">
                            <ExcelColumn label="ID" value="id"/>
                            <ExcelColumn label="Movimiento" value={(col) => col.movementType.name === "" ? col.movementType.id : col.movementType.id + " - " + col.movementType.name}/>
                            <ExcelColumn label="Usuario" value={(col) => col.user.userName}/>
                            <ExcelColumn label="Fecha" value={(col) => formatDate(col.date)}/>
                            <ExcelColumn label="Posición" value="position"/>
                            <ExcelColumn label="Producto" value={(col) => col.product.name}/>
                            <ExcelColumn label="Categoría" value={(col) => col.category == null ? "" : col.category.name}/>
                            <ExcelColumn label="Centro costo" value={(col) => col.costCenter == null ? "" : col.category.id}/>
                            <ExcelColumn label="Planta" value={(col) => col.plant.name}/>
                            <ExcelColumn label="Planta destino" value={(col) => col.destinationPlant == null ? "" : col.destinationPlant.name}/>
                            <ExcelColumn label="Almacén" value={(col) => col.storageLocation == null ? "" : col.storageLocation.name}/>
                            <ExcelColumn label="Almacén destino" value={(col) => col.destinationStorageLocation == null ? "" : col.destinationStorageLocation.name}/>
                            <ExcelColumn label="Costo" value={(col) => col.unitCost}/>
                            <ExcelColumn label="Cantidad" value="quantity"/>
                            <ExcelColumn label="Unidad" value={(col) => col.unitOfMeasure.unit}/>
                            <ExcelColumn label="Movimiento texto" value="text"/>
                        </ExcelSheet>
                        
                    </ExcelFile>
                  </Col>
                  <Col span={24}>
                    <br/>
                    <Table rowKey="key" dataSource={dataTableCompleta} columns={columnsComplete} 
                      loading={tableLoading} scroll={{ x:'auto' }}
                      rowClassName={rowClassColor}/>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tab="Reporte desglosado" key="2">
                <Row>
                  <Col span={24}><br /></Col>

                  <Col span={24}>
                    <br/>
                    <h3>Cabecera</h3>
                    <hr />
                    <Table rowKey="id" dataSource={dataTable} columns={columns} 
                      loading={tableLoading} scroll={{ x:'auto' }}
                      rowClassName={rowClassColor}/>
                  </Col>
                  <Col span={24}>
                    <br/>
                    <h3>Detalle</h3>
                    <hr />
                    <Table rowKey="position" dataSource={dataTableDetalle} columns={columnsDetalle} loading={tableLoadingDetalle} scroll={{ x:'auto' }}/>
                  </Col>
                </Row>
              </TabPane>
            </Tabs>
          </Col>
              
        </Row>
      </div>
    );
}

export default MovementMaterials;



// WEBPACK FOOTER //
// ./src/components/MovementMaterials.jsx